import { render, staticRenderFns } from "./rewardsDetail.vue?vue&type=template&id=0ceb4ff0&scoped=true"
import script from "./rewardsDetail.vue?vue&type=script&lang=js"
export * from "./rewardsDetail.vue?vue&type=script&lang=js"
import style0 from "./rewardsDetail.vue?vue&type=style&index=0&id=0ceb4ff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ceb4ff0",
  null
  
)

export default component.exports